var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-wrapper"},[_c('div',{staticClass:"button",style:(`
      background: ${_vm.background};
      color: ${_vm.color};
      font-weight: ${_vm.bold ? 'bold' : 'normal' }
    `),on:{"click":() => _vm.action()}},[(_vm.icon)?_c('span',[_c('asset-v3',{attrs:{"dir":"icons","name":`${_vm.icon}.svg`}})],1):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }